/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.ScrollableLocationSelector {
    "use strict";

    export class MeevoScrollableLocationSelector implements angular.IDirective {
        restrict = "A";
        scope = {
            isDisabled: '&',
        }

        link = (scope: any, ele: JQuery, attrs: angular.IAttributes) => {
            let mdPanel = this.$mdPanel;
            let rootScope = this.$rootScope;

            function openMenuPanel() {

                if(scope.isDisabled()) {
                    return;
                }

                let position = mdPanel.newPanelPosition()
                    .relativeTo('.scrollable-location-selector')
                    .addPanelPosition(mdPanel.xPosition.ALIGN_END, mdPanel.yPosition.BELOW);

                let config = {
                    attachTo: angular.element(document.body),
                    controller: "meevo.components.scrollableLocationSelector.ScrollableLocationSelectorController",
                    controllerAs: 'ctrl',
                    templateUrl: "app/components/scrollableLocationSelector/scrollableLocationSelector.html",
                    panelClass: 'menu-wrapper',
                    position: position,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: false,
                    zIndex: 100
                };

                mdPanel.open(config);

                setTimeout(() => {
                    rootScope.$broadcast(Meevo.Components.Common.Messages.TYPEAHEAD_FOCUS, 'auto-focus-location');
                }, 0);
            }

            ele.bind("click", openMenuPanel);
        }

        constructor(private $mdPanel: any, private $rootScope: any)
        {}

        static factory(): angular.IDirectiveFactory {
            let directive = ($mdPanel: any, $rootScope: ng.IRootScopeService,) => {
                return new MeevoScrollableLocationSelector($mdPanel, $rootScope);
            };

            directive.$inject = ["$mdPanel", "$rootScope"];

            return directive;
        }
    }

    angular.module("meevo.components.scrollableLocationSelector")
    .directive("meevoScrollableLocationSelector", MeevoScrollableLocationSelector.factory());
}
